/**
 * 管理端统一展示：YYYY-MM-DD HH:mm:ss
 * @param {string|number|Date|null|undefined} v ISO 字符串、时间戳、Date
 * @returns {string}
 */
export function formatDateTime(v) {
  if (v == null || v === '') return '';
  let d;
  if (v instanceof Date) {
    d = v;
  } else if (typeof v === 'number' && Number.isFinite(v)) {
    d = new Date(v < 1e12 ? v * 1000 : v);
  } else {
    const s = String(v).trim();
    if (!s) return '';
    d = new Date(s.indexOf('T') >= 0 ? s : s.replace(' ', 'T'));
  }
  if (Number.isNaN(d.getTime())) {
    return typeof v === 'string' ? v : '';
  }
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
